<script>
/**
 * VANCHEEN 官网页面外壳：页头 + 页面内容 + 页脚 + 回到顶部
 * 原 vancheen-b2b 由 App.vue 统一包裹，这里改为可复用的布局组件。
 * 作用域 CSS（.nw-home 前缀）在此统一引入。
 *
 * 关于 page-home：
 * 原站/home.css 用 .page-home 命名空间给「首页」覆盖了一套绿色主题变量
 * （--primary: #137c60 …），其余页面沿用 base.css 的深蓝 + 橙主题。
 * 原 App.vue 仅在首页路由挂这个类（route.meta.pageKey === 'home'），
 * 这里必须保持一致，否则内页会被首页主题染色。
 */
import NhHeader from './NhHeader.vue'
import NhFooter from './NhFooter.vue'
import NhBackToTop from './NhBackToTop.vue'

import '../styles/nh-base.css'
import '../styles/nh-theme.css'
import '../styles/nh-home.css'

export default {
  name: 'NhShell',
  components: { NhHeader, NhFooter, NhBackToTop },
  computed: {
    /** 仅首页使用首页主题作用域 */
    isHomePage() {
      return this.$route && this.$route.path === '/'
    }
  }
}
</script>

<template>
  <div class="nw-home">
    <div :class="{ 'page-home': isHomePage }">
      <NhHeader />
      <main>
        <slot />
      </main>
      <NhFooter />
      <NhBackToTop />
    </div>
  </div>
</template>
